export const DATA_CORRECTION_FORM_MODEL = {
  formBox: {
    controlType: 'ssForm',
    controlId: 'formBox',
    parent: 'root',
    childrenNodes: [
      '6478-2a84-2012213173447850-b0d6-f394',
      '4317-f376-201991173013704-fad0-ead3',
      'bb09-56b0-2011119122410781-6a5e-0a22',
    ],
  },
  '6478-2a84-2012213173447850-b0d6-f394': {
    controlType: 'ssPanel',
    controlId: '6478-2a84-2012213173447850-b0d6-f394',
    parent: 'e63c-3b2b-20221012152014156-17cd-b202',
    entityName: '',
    title: 'Data Correction',
    childrenNodes: ['7533-a6e4-201291201629224-144d-33f2'],
  },
  '7533-a6e4-201291201629224-144d-33f2': {
    controlType: 'ssDataCorrection',
    controlId: '7533-a6e4-201291201629224-144d-33f2',
    parent: '6478-2a84-2012213173447850-b0d6-f394',
    childrenNodes: [],
  },
  '4317-f376-201991173013704-fad0-ead3': {
    controlType: 'ssPanel',
    controlId: '4317-f376-201991173013704-fad0-ead3',
    parent: 'formBox',
    entityName: 'V_SS_CAPA',
    header: 'false',
    collapsed: 'false',
    hasMargin: 'false',
    defaultLabel: 'Select To Change',
    childrenNodes: ['5f8e9aa7-09cb-46e4-8348-3c585a06a821', '2397-5043-2012418174057181-1322-5ec1'],
  },
  '2397-5043-2012418174057181-1322-5ec1': {
    controlType: 'ssTextArea',
    controlId: '2397-5043-2012418174057181-1322-5ec1',
    parent: '4317-f376-201991173013704-fad0-ead3',
    entityName: 'V_ENU_NONPERSIS_USER_DATA',
    fieldName: 'ENU_COMMENT',
    rows: '5',
    columns: '100',
    label: 'Comment',
    required: 'true',
    childrenNodes: [],
  },
  '5f8e9aa7-09cb-46e4-8348-3c585a06a821': {
    controlType: 'ssTextBox',
    controlId: '5f8e9aa7-09cb-46e4-8348-3c585a06a821',
    parent: '4317-f376-201991173013704-fad0-ead3',
    entityName: 'V_ENU_NONPERSIS_USER_DATA',
    fieldName: 'ENU_SECRET_KEY',
    label: 'Secret Key',
    required: 'true',
    secure: 'true',
    childrenNodes: [],
  },
  'bb09-56b0-2011119122410781-6a5e-0a22': {
    controlType: 'ssPanel',
    controlId: 'bb09-56b0-2011119122410781-6a5e-0a22',
    parent: 'formBox',
    entityName: '',
    title: '',
    childrenNodes: ['27f7-4117-2012911112610720-5058-a65a', '63d9-5b0d-201291201630396-1ecc-8b8b'],
  },
  '27f7-4117-2012911112610720-5058-a65a': {
    controlType: 'ssButton',
    controlId: '27f7-4117-2012911112610720-5058-a65a',
    parent: 'bb09-56b0-2011119122410781-6a5e-0a22',
    buttonType: 'Cancel',
    icon: 'cancel',
    childrenNodes: [],
  },
  '63d9-5b0d-201291201630396-1ecc-8b8b': {
    controlType: 'ssButton',
    controlId: '63d9-5b0d-201291201630396-1ecc-8b8b',
    parent: 'bb09-56b0-2011119122410781-6a5e-0a22',
    buttonType: 'Save',
    icon: 'submit',
    needSignature: 'true',
    causesValidation: 'true',
    label: 'Sign-Off',
    childrenNodes: [],
    uniqueIdentifier: 'btnSubmit',
  },
};
